<template>
  <el-menu
    :default-active="activeStepStr"
    class="el-menu-steps"
    mode="horizontal"
    background-color="#020a15"
    text-color="#fff"
    active-text-color="#86C79C"
    @select="handleSelect"
  >
    <el-menu-item index="2" :disabled="!allowedSteps[0]">
      <div class="el-menu-steps step-id">Step 1</div>
      <div class="el-menu-steps step-label">{{stepNames[0]}}</div>
    </el-menu-item>
    <el-menu-item index="2" :disabled="!allowedSteps[1]">
      <div class="el-menu-steps step-id">Step 2</div>
      <div class="el-menu-steps step-label">{{stepNames[1]}}</div>
    </el-menu-item>
    <el-menu-item index="3" :disabled="!allowedSteps[2]">
      <div class="el-menu-steps step-id">Step 3</div>
      <div class="el-menu-steps step-label">{{stepNames[2]}}</div>
    </el-menu-item>
    <el-menu-item index="4" :disabled="!allowedSteps[3]">
      <div class="el-menu-steps step-id">Step 4</div>
      <div class="el-menu-steps step-label">{{stepNames[3]}}</div>
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "StepNav",
  components: {},
  mixins: [],
  props: {
    activeStep: {
      type: Number,
      default: 1,
    },
    allowedSteps: {
      type: Array,
      default: () => [],
    },
    stepNames: {
      type: Array,
      default: () => ["REPORT TYPE","CUSTOMISATIONS","JURISDICTIONS","VIEW YOUR CUSTOM REPORT"],
    }
  },
  computed: {
    activeStepStr() {
      return this.activeStep.toString();
    },
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$emit("setStep", parseInt(key));
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

main.ul {
  padding: none;
}

.el-menu-steps {
  margin-left: 0px !important;
  padding-left: 0px !important;
  padding-bottom: 0px !important;

  .step-id {
    color: $brightGreen;
    height: 2rem;
  }

  .step-label {
    color: $white;
    font-weight: 700;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
  height: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 5px solid $brightGreen;
  color: $white !important;
}

.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 72px;
  line-height: 60px;
  margin: 0;
  border-bottom: 2px solid transparent;
  color: $menuItemColor;
  margin-right: 17px;
}

.el-menu-item {
  width: 30rem;
}
</style>
